import { useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';
import { Snackbar as MUISnackbar } from '@mui/material';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { Subscription } from 'rxjs';
import { useNotifications } from './notifications.hook';

const Alert = MuiAlert as React.FC<AlertProps>;

export const Snackbar = () => {
  const { getNotification$ } = useNotifications();

  const [snack, setSnack] = useState<{
    type: 'success' | 'error' | 'warning' | 'info';
    message: string;
  } | null>(null);

  useEffect(() => {
    const subscription: Subscription = getNotification$().subscribe(setSnack);

    return () => subscription.unsubscribe();
  }, []);

  const handleClose = (
    _event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') return;
    setSnack(null);
  };

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <MUISnackbar
        open={Boolean(snack)}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={snack?.type || 'info'}
          sx={{ width: '100%' }}
        >
          {snack?.message || ''}
        </Alert>
      </MUISnackbar>
    </Stack>
  );
};
